import React, { ErrorInfo } from 'react';
import { IFallbackComponent } from 'components/ErrorBoundary/fallback/FallBackHeader/FallBackHeader';

interface IProps {
	children: React.ReactNode;
	FallbackComponent: React.ComponentType<IFallbackComponent>;
	errorLogger?: () => void;
}

interface IState {
	hasError: boolean;
}

class ErrorBoundary extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(): IState {
		return { hasError: true };
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		// console.log(error.stack);
		// console.log(errorInfo);
		this.props.errorLogger?.() || console.error('Uncaught error: ', error, errorInfo);
	}

	public reset() {
		this.setState({ hasError: false });
	}

	public render() {
		if (this.state.hasError) {
			return <this.props.FallbackComponent onResetError={() => this.reset()} />;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
